import { useMemo } from 'react';
import { useQuery } from '@apollo/react-hooks';

import type { ConnectCustomContentModulesQuery as customContentModulesQuery } from './__types__/ConnectCustomContentModulesQuery';
import { ConnectCustomContentModulesQuery } from './ConnectCustomContentModulesQuery.experimentalgraphql';

export const useCustomContentConnectModules = ({ skip }: { skip: boolean } = { skip: false }) => {
	const { data, loading, error } = useQuery<customContentModulesQuery>(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
		ConnectCustomContentModulesQuery,
		{
			skip,
		},
	);

	return useMemo(
		() => ({
			modules: data?.experimentalCustomContentConnectModules?.modules || [],
			loading,
			error,
		}),
		[data, loading, error],
	);
};
